'use strict';

/* eslint no-undef: "off" */
/**
 * newsletter content
 */
define('homeNewsletter',['jquery', 'homeNewsletterApi', 'util', 'transitionForEn', 'transitionForAr', 'transitionForFr', 'GAReport'], function ($, homeNewsletterApi, Util, transitionForEn, transitionForAr, transitionForFr, GAReport) {
  return {
    template: '\n      <div class="in-home-newsletter">\n        <div class="in-container">\n          <form class="newsletter-form" @submit.prevent="validateBeforeSubmit">\n            <h6 class="font-medium" v-text="i18n.title"></h6>\n            <p v-text="i18n.description"></p>\n            <div class="in-newsletter">\n              <input type="text" :name="i18n.email" v-model="newsletter" :placeholder="i18n.pleaseEmail" autocomplete="off" v-validate="\'required|email\'" :class="{\'input\': true, \'is-danger\': errors.has(i18n.email) }" />\n              <button type="submit" v-text="i18n.subscribe"></button>\n            </div>\n            <span v-show="errors.has(i18n.email)" class="help is-danger">{{ errors.first(i18n.email) }}</span>\n          </form>\n          <!--\n          <div class="newsletter-image-area">\n            <img class="newsletter-image" :src="require.toUrl(\'images/newsletter_phone.png\')" />\n          </div>\n          -->\n          <div class="download-app">\n            <h6 class="font-medium" v-text="i18n.download"></h6>\n            <ul>\n              <li v-text="i18n.downloadDes"></li>\n            </ul>\n            <div class="content">\n              <div class="content-top">\n                <img class="google-play" :src="require.toUrl(\'images/google-play.png\')"/>\n                <div class="content-search">\n                  <span>XPARK</span>\n                  <img :src="require.toUrl(\'images/download-search.png\')"/>\n                </div>\n              </div>\n              <div class="content-bottom">\n                <ul>\n                  <li v-text="i18n.downloadText"></li>\n                </ul>\n              <img :src="require.toUrl(\'images/download-right.png\')"/>\n              </div>\n            </div>\n            <img id="qr-code" :src="require.toUrl(\'images/QR-code.png\')"/>\n          </div>\n          <div>\n            <img class="footer-phone" :src="require.toUrl(\'images/footer-phone.png\')"/>\n          </div>\n        </div>\n      </div>\n    ',
    data: function data() {
      return {
        i18n: {
          title: 'SIGN UP FOR LUCKYDRAW',
          description: 'Exclusive offer for new member',
          pleaseEmail: 'Your email address',
          subscribe: 'Subscribe',
          email: 'email',
          download: 'Download XPARK App',
          downloadDes: 'Search XPARK in Google Play to download',
          downloadText: 'Or Scan QR code on the left'
        },
        newsletter: '',
        iconSuccess: '' // success/error/hint
      };
    },
    created: function created() {
      this.initTransition();
    },

    methods: {
      validateBeforeSubmit: function validateBeforeSubmit() {
        var _this = this;

        this.$validator.validateAll().then(function (result) {
          if (result) {
            return _this.submit();
          }
        });
      },
      submit: function submit() {
        var _this2 = this;

        homeNewsletterApi({
          email: this.newsletter
        }).then(function (resData) {
          _this2.$root.success(resData.msg);
        });

        new GAReport().customerClick({
          eventAction: 'TOP_SUBSCRIBTION_SUBMIT',
          eventCategory: 'TOP_SUBSCRIBTION_#VERSION#'
        });
      },

      /**
       * 注入英文翻译
       */
      initTransition: function initTransition() {
        var language = $('html').attr('lang');
        if (language === 'en') {
          this.$validator.localize('en', {
            messages: transitionForEn.messages
          });
        } else if (language === 'ar') {
          this.$validator.localize('ar', {
            messages: transitionForAr.messages
          });
        } else if (language === 'fr') {
          this.$validator.localize('fr', {
            messages: transitionForFr.messages
          });
        }
      }
    }
  };
});
